/* eslint-disable no-param-reassign */
import { useMemo } from 'react';
import { types } from 'mobx-state-tree';
import type {
  Instance,
  SnapshotIn,
  SnapshotOut,
} from 'mobx-state-tree/dist/core/type/type';

import { initializeStore } from '@/stores';

export const AppStore = types
  .model({
    loading: false,
  })
  .actions((self) => ({
    setLoading(loading: boolean) {
      self.loading = loading;
    },
  }))
  .named('AppStore');

export const useAppStore = (
  initialState: IAppStoreSnapshotIn | null = null,
): AppStoreType => {
  return useMemo(() => initializeStore(AppStore, initialState), [initialState]);
};

export type AppStoreType = Instance<typeof AppStore> & {};

export type IAppStoreSnapshotIn = SnapshotIn<typeof AppStore> & {};

export type IAppStoreSnapshotOut = SnapshotOut<typeof AppStore> & {};
